// extracted by mini-css-extract-plugin
export default {"container":"ser-sec_container__pmKMC","title":"ser-sec_title__FEPZc","list_item":"ser-sec_list_item__kCuKn","bottom":"ser-sec_bottom__wxovk","item":"ser-sec_item__2fuIH"};